import { IKeyValuePair } from "types/general/IKeyValuePair";

export interface ITableFilter extends IKeyValuePair
{
	operator: FilterOperators,
	// filterType: TableFilterTypes
}

// https://github.com/Biarity/Sieve
export enum FilterOperators
{
	undefined = 'undefined',
	equals = 'eq',
	equalsNumber = 'eqn',
	notEquals = 'neq',
	contains = 'ct',
	startsWith = 'sw',
	lessThan = 'lt',
	greatherThan = 'gt',
	dateRange = 'dr'
}

export enum TableFilterTypes
{
	default = 0,
	dateRange = 1
}